<template>

    <form ref="questao-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            <div class="form-group col-md-3">
                <label for="disciplinaId">Disciplina</label>
                <select v-select="{ dataitem: 'AuxDisciplina', default: 'Selecione' }" v-model="model.disciplinaId" class="form-control" name="disciplinaId" required></select>
            </div>
            <div class="form-group col-md-3">
                <label for="dificuldadeId">Dificuldade</label>
                <select v-select="{ dataitem: 'AuxDificuldade', default: 'Selecione' }" v-model="model.dificuldadeId" class="form-control" name="dificuldadeId" required></select>
            </div>
            <div class="form-group col-md-3">
                <label for="tipoRespostaId">Tipo da Resposta</label>
                <select v-select="{ dataitem: 'AuxTipoResposta', default: 'Selecione' }" v-model="model.tipoRespostaId" class="form-control" name="tipoRespostaId" required></select>
            </div>
            <div class="form-group col-md-3">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ehAtivo" class="custom-control-input" v-model="model.ehAtivo">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Ativo?</span>
                </label>
            </div>

            <div class="col-md-12">
                <b-tabs>
                    <b-tab title="Enunciado" active>
                        <br />
                        <em>Caso você precise subir vídeos, favor não ultrapassar 2MB por vídeos/Audio</em>
                        <textarea v-model="model.enunciado" v-htmleditor></textarea>
                    </b-tab>

                    <b-tab title="Visualizar">
                        <br />
                        <div v-html="model.enunciado"></div>
                        <hr />
                    </b-tab>

                </b-tabs>
                <br />
            </div>

        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Próximo passo</span>
        </button>

    </form>


</template>
<script>
    

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "questao-form-create",
        components: {},
        mixins: [base],
        data: () => ({

            model: {
                disciplinaId: "",
                dificuldadeId: "",
                tipoRespostaId: "",

            },
            tipoResposta: {},

            form: "questao-form-create",

            resources: {
                create: 'questao',
            },

        }),

        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                var _valid = $form.checkValidity();
                if (!_valid) this.defaultErrorResult("Preencha todos os campos obrigatórios");
                return _valid;
            },

            onBack: function () {
                this.$emit('on-back')
            },

        },
    };
</script>

